export default "__VITE_ASSET__1bacb5b2__"